import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { DispatchContext } from 'context';
import { useSnackbar } from 'notistack';
import './formulario-descuento-cheques.css';
import { FormControl, FormControlLabel, Radio, RadioGroup, TextField, InputLabel, MenuItem, Select } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk, faMapPin, faPlus } from '@fortawesome/free-solid-svg-icons';

// import FileInput from '@brainhubeu/react-file-input';
// import '@brainhubeu/react-file-input/dist/react-file-input.css';

import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';

import AdapterMoment from '@mui/lab/AdapterMoment';
import { DatePicker } from '@mui/lab';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import moment from 'moment';

import { SelectBarrio, SelectCiudad, SelectEstadoCivil, SelectProfesion, SelectCargo, SelectNacionalidad } from 'app/selects';
import { FileThumb } from 'components/file-thumb';
import { ModalEdicionFile } from 'app/modal-edicion-file';
import { ModalExito } from 'app/modal-exito';
import { ModalError } from 'app/modal-error';
import { scroller } from 'react-scroll';

import GoogleMapReact from 'google-map-react';

const valorInicial = {
    IDSOLICITUD: 0,
    NOMBRE: "",
    APELLIDO: "",
    NUMERO_DOCUMENTO: "",
    IDNACIONALIDAD: "",
    FECHA_NACIMIENTO: moment().subtract(18, "years"),
    ESTADO_CIVIL: "",
    IDESTADO_CIVIL: "",
    TELEFONO: "",
    CELULAR: "",
    EMAIL: "",
    IDTIPO_CASA: 1,
    DIRECCION: "",
    IDPROFESION: "",
    IDCARGO: "",
    IDBARRIO: "",
    IDCIUDAD: "",
    PROFESION: "",
    LUGAR_TRABAJO: "",
    CARGO_LABORAL: "",
    DEPARTAMENTO_LABORAL: "",
    ANTIGUEDAD_ANHO: "",
    TELEFONO_LABORAL: "",
    EMAIL_LABORAL: "",
    DOMICILIO_LABORAL: "",
    IDBARRIO_LABORAL: "",
    IDCIUDAD_LABORAL: "",
    REFERENCIAS_PERSONALES: [
        { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
        { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
        { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
    ],
    NUM_CHEQUES: 1,
    MONTO: ""
};
const errorInicial = {
    NOMBRE: false,
    APELLIDO: false,
    NUMERO_DOCUMENTO: false,
    NACIONALIDAD: false,
    FECHA_NACIMIENTO: false,
    ESTADO_CIVIL: false,
    IDESTADO_CIVIL: false,
    TELEFONO: false,
    CELULAR: false,
    EMAIL: false,
    IDTIPO_CASA: false,
    DIRECCION: false,
    IDPROFESION: false,
    IDCARGO: false,
    IDBARRIO: false,
    IDCIUDAD: false,
    PROFESION: false,
    LUGAR_TRABAJO: false,
    CARGO_LABORAL: false,
    DEPARTAMENTO_LABORAL: false,
    ANTIGUEDAD_ANHO: false,
    TELEFONO_LABORAL: false,
    EMAIL_LABORAL: false,
    DOMICILIO_LABORAL: false,
    IDBARRIO_LABORAL: false,
    IDCIUDAD_LABORAL: false,
    NUM_CHEQUES: false,
    MONTO: false,
    REFERENCIAS_PERSONALES: [
        { NOMBRE: false, TELEFONO: false },
        { NOMBRE: false, TELEFONO: false },
        { NOMBRE: false, TELEFONO: false },
    ],
};
const FormularioDescuentoCheques = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    // const state = useContext(StateContext);
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    const [data, setData] = useState({ ...valorInicial });
    const [tokenReCaptcha, setTokenReCaptcha] = useState(null);
    const [barrios, setBarrios] = useState([]);
    const [barriosLaborales, setBarriosLaborales] = useState([]);

    const [fileCedulaIdentidad, setFileCedulaIdentidad] = useState(null);
    const [fileExtractoCtaCte, setFileExtractoCtaCte] = useState(null);
    const [fileIva, setFileIva] = useState(null);
    const [fileConstitucionSa, setFileConstitucionSa] = useState(null);
    const [fileActaAsamblea, setFileActaAsamblea] = useState(null);
    const [fileCanjeAcciones, setFileCanjeAcciones] = useState(null);
    const [fileCctVigente, setFileCctVigente] = useState(null);
    const [coordenadas, setCoordenadas] = useState(null);

    const [modalFile, setModalFile] = useState(false);
    const [fileEdicion, setFileEdicion] = useState(null);
    const acceptFiles = ".jpg,.png,.jpeg,.gif,.svg,.pdf";
    const [showModalExito, setShowModalExito] = useState(false);
    const [showModalError, setShowModalError] = useState(false);

    const maxDate = moment().subtract(18, "years");

    const tipoCasaOptions = [
        { value: 1, label: "Casa propia" },
        { value: 2, label: "Familiar" },
        { value: 3, label: "Alquilada" },
    ];
    const cantChequesOptions = [
        { value: 1, label: "1 Cheque" },
        { value: 2, label: "2 Cheques" },
        { value: 3, label: "3 Cheques" },
        { value: 4, label: "4 Cheques" },
        { value: 5, label: "5 Cheques" },
        { value: 6, label: "6 Cheques" },
        { value: 7, label: "7 Cheques" },
        { value: 8, label: "8 Cheques" },
        { value: 9, label: "9 Cheques" },
        { value: 10, label: "10 Cheques" },
        { value: 11, label: "11 Cheques" },
        { value: 12, label: "12 Cheques" }
    ];
    const antiguedadAnhosOptions = [
        { value: 1, label: "Más de 1 año" },
        { value: 2, label: "Más de 2 años" },
        { value: 3, label: "Más de 3 años" },
        { value: 4, label: "Más de 4 años" },
        { value: 5, label: "Más de 5 años" }
    ];

    const Marcador = ({ text }) => <FontAwesomeIcon icon={faMapPin} color="#0a5aa7" size="4x" />;

    const [errores, setErrores] = useState(errorInicial);
    useEffect(() => {
        setFileExtractoCtaCte(null);
        setFileIva(null);
        setFileCedulaIdentidad(null);
        setFileConstitucionSa(null);
        setFileActaAsamblea(null);
        setFileCanjeAcciones(null);
        setFileCctVigente(null);
        setData({ ...data, TIPO_SOLICITUD: props.tipoSolicitud });
    }, []);
    const onChangeForm = (event, campo) => {
        let value = event.target.value;
        if (campo === 'MONTO') {
            if (value.length > 10) {
                return;
            }
            value = Helper.numberUi(value.replaceAll('.', ''));
        }
        if (campo === 'NUMERO_DOCUMENTO') {
            value = Helper.numberUi(value.replaceAll('.', ''));
        }
        setData({
            ...data,
            [campo]: value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const onChangeReferencia = (index, event, campo) => {
        let referencias = [...data.REFERENCIAS_PERSONALES];
        referencias[index][campo] = event.target.value;
        let erroresReferencias = [...errores.REFERENCIAS_PERSONALES];
        erroresReferencias[index][campo] = false;
        setData({
            ...data,
            REFERENCIAS_PERSONALES: referencias
        });
        setErrores({
            ...errores,
            REFERENCIAS_PERSONALES: erroresReferencias
        });
    }
    const onChangeNacionalidad = (idnacionalidad) => {
        setData({
            ...data,
            IDNACIONALIDAD: idnacionalidad
        });
        setErrores({
            ...errores,
            IDNACIONALIDAD: false
        });
    }
    const onChangeFechaNacimiento = (nuevaFecha) => {
        setData({
            ...data,
            FECHA_NACIMIENTO: nuevaFecha
        });
        setErrores({
            ...errores,
            FECHA_NACIMIENTO: false
        });
    }
    const onChangeEstadoCivil = (idestadocivil) => {
        setData({
            ...data,
            IDESTADO_CIVIL: idestadocivil,
        });
        setErrores({
            ...errores,
            IDESTADO_CIVIL: false
        });
    }
    const onChangeProfesion = (idprofesion) => {
        setData({
            ...data,
            IDPROFESION: idprofesion,
        });
        setErrores({
            ...errores,
            IDPROFESION: false
        });
    }
    const onChangeCargo = (idcargo) => {
        setData({
            ...data,
            IDCARGO: idcargo,
        });
        setErrores({
            ...errores,
            IDCARGO: false
        });
    }
    const onChangeCiudad = (idciudad, barrs) => {
        setData({
            ...data,
            IDCIUDAD: idciudad,
            IDBARRIO: ""
        });
        setErrores({
            ...errores,
            IDCIUDAD: false
        });
        setBarrios(barrs);
    }
    const onChangeCiudadLaboral = (idciudad, barrs) => {
        setData({
            ...data,
            IDCIUDAD_LABORAL: idciudad,
            IDBARRIO_LABORAL: ""
        });
        setErrores({
            ...errores,
            IDCIUDAD_LABORAL: false
        });
        setBarriosLaborales(barrs);
    }
    const solicitar = () => {
        const { IDSOLICITUD, NOMBRE, APELLIDO, NUMERO_DOCUMENTO, IDNACIONALIDAD, FECHA_NACIMIENTO, ESTADO_CIVIL, IDESTADO_CIVIL, TELEFONO, CELULAR, EMAIL,
            IDTIPO_CASA, DIRECCION, IDBARRIO, IDCIUDAD,
            PROFESION, IDPROFESION, LATITUDE, LONGITUDE, CARGO_LABORAL, IDCARGO, DEPARTAMENTO_LABORAL, ANTIGUEDAD_ANHO, TELEFONO_LABORAL, EMAIL_LABORAL, DOMICILIO_LABORAL, IDBARRIO_LABORAL, IDCIUDAD_LABORAL,
            REFERENCIAS_PERSONALES, MONTO, NUM_CHEQUES,
            RAZON_SOCIAL_EMPRESA, RUC_EMPRESA, TELEFONO_EMPRESA, DIRECCION_EMPRESA} = data;
        let todoBien = true;
        let datos = {};
        let errors = {};
        if (NOMBRE && NOMBRE !== "") {
            datos.NOMBRE = NOMBRE;
        } else {
            todoBien = false;
            errors.NOMBRE = true;
        }
        if (APELLIDO && APELLIDO !== "") {
            datos.APELLIDO = APELLIDO;
        } else {
            todoBien = false;
            errors.APELLIDO = true;
        }
        if (NUMERO_DOCUMENTO && NUMERO_DOCUMENTO !== "") {
            datos.NUMERO_DOCUMENTO = NUMERO_DOCUMENTO.replaceAll('.', '');
        } else {
            todoBien = false;
            errors.NUMERO_DOCUMENTO = true;
        }
        if (IDNACIONALIDAD && IDNACIONALIDAD !== "") {
            datos.IDNACIONALIDAD = IDNACIONALIDAD;
        } else {
            // todoBien = false;
            // errors.IDNACIONALIDAD = true;
        }
        if (FECHA_NACIMIENTO && FECHA_NACIMIENTO !== "") {
            datos.FECHA_NACIMIENTO = moment(FECHA_NACIMIENTO).format("YYYY-MM-DD");
        } else {
            todoBien = false;
            errors.FECHA_NACIMIENTO = true;
        }
        // if (ESTADO_CIVIL && ESTADO_CIVIL !== "") {
        //     datos.ESTADO_CIVIL = ESTADO_CIVIL;
        // } else {
        //     todoBien = false;
        //     errors.ESTADO_CIVIL = true;
        // }
        if (IDESTADO_CIVIL && IDESTADO_CIVIL !== "") {
            datos.IDESTADO_CIVIL = IDESTADO_CIVIL;
        } else {
            todoBien = false;
            errors.IDESTADO_CIVIL = true;
        }
        if (TELEFONO && TELEFONO !== "") {
            datos.TELEFONO = TELEFONO;
        } else {
            // todoBien = false;
            // errors.TELEFONO = true;
        }
        if (CELULAR && CELULAR !== "") {
            datos.CELULAR = CELULAR;
        } else {
            todoBien = false;
            errors.CELULAR = true;
        }
        if (EMAIL && EMAIL !== "" && Helper.validateEmail(EMAIL)) {
            datos.EMAIL = EMAIL;
        } else {
            if (EMAIL && EMAIL !== "" && !Helper.validateEmail(EMAIL)) {
                todoBien = false;
                errors.EMAIL = true;
            } else {
                // todoBien = false;
                // errors.EMAIL = true;
            }
        }
        if (DIRECCION && DIRECCION !== "") {
            datos.DIRECCION = DIRECCION;
        } else {
            todoBien = false;
            errors.DIRECCION = true;
        }
        if (IDTIPO_CASA && IDTIPO_CASA !== "") {
            datos.IDTIPO_CASA = IDTIPO_CASA;
        } else {
            todoBien = false;
            errors.IDTIPO_CASA = true;
        }
        if (IDBARRIO && IDBARRIO !== "") {
            datos.IDBARRIO = IDBARRIO;
        } else {
            // todoBien = false;
            // errors.IDBARRIO = true;
        }
        if (IDCIUDAD && IDCIUDAD !== "") {
            datos.IDCIUDAD = IDCIUDAD;
        } else {
            todoBien = false;
            errors.IDCIUDAD = true;
            // enqueueSnackbar('Seleccione la ciudad donde se encuentra su domicilio', { variant: 'error' });
        }
        // if (PROFESION && PROFESION !== "") {
        //     datos.PROFESION = PROFESION;
        // } else {
        //     todoBien = false;
        //     errors.PROFESION = true;
        // }
        if (IDPROFESION && IDPROFESION !== "") {
            datos.IDPROFESION = IDPROFESION;
        } else {
            todoBien = false;
            errors.IDPROFESION = true;
        }
        // if (LUGAR_TRABAJO && LUGAR_TRABAJO !== "") {
        //     datos.LUGAR_TRABAJO = LUGAR_TRABAJO;
        // } else {
        //     todoBien = false;
        //     errors.LUGAR_TRABAJO = true;
        // }
        // if (CARGO_LABORAL && CARGO_LABORAL !== "") {
        //     datos.CARGO_LABORAL = CARGO_LABORAL;
        // } else {
        //     todoBien = false;
        //     errors.CARGO_LABORAL = true;
        // }
        if (IDCARGO && IDCARGO !== "") {
            datos.IDCARGO = IDCARGO;
        } else {
            todoBien = false;
            errors.IDCARGO = true;
        }
        if (DEPARTAMENTO_LABORAL && DEPARTAMENTO_LABORAL !== "") {
            datos.DEPARTAMENTO_LABORAL = DEPARTAMENTO_LABORAL;
        } else {
            todoBien = false;
            errors.DEPARTAMENTO_LABORAL = true;
        }
        if (ANTIGUEDAD_ANHO && ANTIGUEDAD_ANHO !== "") {
            datos.ANTIGUEDAD_ANHO = ANTIGUEDAD_ANHO;
        } else {
            todoBien = false;
            errors.ANTIGUEDAD_ANHO = true;
        }
        if (TELEFONO_LABORAL && TELEFONO_LABORAL !== "") {
            datos.TELEFONO_LABORAL = TELEFONO_LABORAL;
        } else {
            todoBien = false;
            errors.TELEFONO_LABORAL = true;
        }
        if (EMAIL_LABORAL && EMAIL_LABORAL !== "" && Helper.validateEmail(EMAIL_LABORAL)) {
            datos.EMAIL_LABORAL = EMAIL_LABORAL;
        } else {
            if (EMAIL_LABORAL && EMAIL_LABORAL !== "" && !Helper.validateEmail(EMAIL_LABORAL)) {
                todoBien = false;
                errors.EMAIL_LABORAL = true;
            }
        }
        if (DOMICILIO_LABORAL && DOMICILIO_LABORAL !== "") {
            datos.DOMICILIO_LABORAL = DOMICILIO_LABORAL;
        } else {
            todoBien = false;
            errors.DOMICILIO_LABORAL = true;
        }
        if (IDBARRIO_LABORAL && IDBARRIO_LABORAL !== "") {
            datos.IDBARRIO_LABORAL = IDBARRIO_LABORAL;
        } else {
            // todoBien = false;
            // errors.IDBARRIO_LABORAL = true;
        }
        if (IDCIUDAD_LABORAL && IDCIUDAD_LABORAL !== "") {
            datos.IDCIUDAD_LABORAL = IDCIUDAD_LABORAL;
        } else {
            todoBien = false;
            errors.IDCIUDAD_LABORAL = true;
        }
        if (typeof LATITUDE !== 'undefined' && LATITUDE !== "") {
            datos.LATITUDE = LATITUDE;
        } else {
            // todoBien = false;
            // errors.LATITUDE = true;
        }
        if (typeof LONGITUDE !== 'undefined' && LONGITUDE !== "") {
            datos.LONGITUDE = LONGITUDE;
        } else {
            // todoBien = false;
            // errors.LONGITUDE = true;
        }
        if (REFERENCIAS_PERSONALES && REFERENCIAS_PERSONALES.length > 0) {
            let referencias = [];
            let erroresReferencias = [
                { NOMBRE: false, TELEFONO: false },
                { NOMBRE: false, TELEFONO: false },
                { NOMBRE: false, TELEFONO: false },
            ];
            for (let i in REFERENCIAS_PERSONALES) {
                let referencia = {
                    IDREFERENCIA: 0
                };
                if (REFERENCIAS_PERSONALES[i].NOMBRE && REFERENCIAS_PERSONALES[i].NOMBRE !== "") {
                    referencia.NOMBRE = REFERENCIAS_PERSONALES[i].NOMBRE;
                } else {
                    todoBien = false;
                    erroresReferencias[i].NOMBRE = true;
                }
                if (REFERENCIAS_PERSONALES[i].TELEFONO && REFERENCIAS_PERSONALES[i].TELEFONO !== "") {
                    referencia.TELEFONO = REFERENCIAS_PERSONALES[i].TELEFONO;
                } else {
                    todoBien = false;
                    erroresReferencias[i].TELEFONO = true;
                }
                referencias.push(referencia);
            }
            datos.REFERENCIAS_PERSONALES = referencias;
            errors.REFERENCIAS_PERSONALES = erroresReferencias;
        } else {
            todoBien = false;
            // errors.REFERENCIAS_PERSONALES = true;
        }

        if (props.tipoSolicitud === 5) {
            if (RAZON_SOCIAL_EMPRESA && RAZON_SOCIAL_EMPRESA !== "") {
                datos.RAZON_SOCIAL_EMPRESA = RAZON_SOCIAL_EMPRESA;
            } else {
                todoBien = false;
                errors.RAZON_SOCIAL_EMPRESA = true;
            }
            if (RUC_EMPRESA && RUC_EMPRESA !== "") {
                datos.RUC_EMPRESA = RUC_EMPRESA;
            } else {
                todoBien = false;
                errors.RUC_EMPRESA = true;
            }
            if (DIRECCION_EMPRESA && DIRECCION_EMPRESA !== "") {
                datos.DIRECCION_EMPRESA = DIRECCION_EMPRESA;
            } else {
                todoBien = false;
                errors.DIRECCION_EMPRESA = true;
            }
            if (TELEFONO_EMPRESA && TELEFONO_EMPRESA !== "") {
                datos.TELEFONO_EMPRESA = TELEFONO_EMPRESA;
            } else {
                todoBien = false;
                errors.TELEFONO_EMPRESA = true;
            }
        }

        if (NUM_CHEQUES && NUM_CHEQUES !== "") {
            datos.NUM_CHEQUES = NUM_CHEQUES;
        } else {
            todoBien = false;
            errors.NUM_CHEQUES = true;
        }
        if (MONTO && MONTO !== "") {
            datos.MONTO = MONTO.replaceAll('.', '');
        } else {
            todoBien = false;
            errors.MONTO = true;
        }

        console.log('data', data);
        if (todoBien) {
            console.log('data', data);
        } else {
            setShowModalError(true);
            // enqueueSnackbar('Debes completar todos los datos requeridos', { variant: 'error' });
        }
        console.log('todoBien', todoBien);
        console.log('errores', errors);
        console.log('datos', datos);
        setErrores(errors);
        if (todoBien) {
            datos.IDSOLICITUD = IDSOLICITUD;
            datos.IDTIPO_SOLICITUD = props.tipoSolicitud;
            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            var options = {
                url: Api.route('/solicitudes/solicitudes/guardar'),
                method: 'POST',
                data: datos
            };
            Api.request(options, response => {
                Helper.log('guardarSolicitud response', response);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                } else if (response.codigo && response.codigo === 200) {
                    setData({ ...valorInicial });
                    setCoordenadas(null);
                    setShowModalExito(true);
                    // enqueueSnackbar("Hemos recibido tu solicitud, nos comunicaremos contigo para ayudarte con los siguientes pasos", { variant: 'success' });
                    // setMsgEnvioExitoso("Hemos recibido tu solicitud, nos comunicaremos contigo para ayudarte con los siguientes pasos");
                    setTimeout(() => {
                        setData({
                            ...valorInicial, REFERENCIAS_PERSONALES: [
                                { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
                                { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
                                { IDREFERENCIA: 0, NOMBRE: "", TELEFONO: "" },
                            ]
                        });
                        // setMsgEnvioExitoso("");
                    }, 500);
                    // let documentos = [
                    //     { idtipo: 2, archivo: fileCedulaIdentidad, setter: setFileCedulaIdentidad },
                    //     { idtipo: 14, archivo: fileExtractoCtaCte, setter: setFileExtractoCtaCte },
                    //     { idtipo: 13, archivo: fileIva, setter: setFileIva },
                    //     { idtipo: 27, archivo: fileConstitucionSa, setter: setFileConstitucionSa },
                    //     { idtipo: 28, archivo: fileActaAsamblea, setter: setFileActaAsamblea },
                    //     { idtipo: 38, archivo: fileCanjeAcciones, setter: setFileCanjeAcciones },
                    //     { idtipo: 23, archivo: fileCctVigente, setter: setFileCctVigente }
                    // ];
                    let documentos = [];
                    if (props.tipoSolicitud === 4) {
                        documentos = [
                            { idtipo: 2, archivo: fileCedulaIdentidad, setter: setFileCedulaIdentidad },
                            { idtipo: 14, archivo: fileExtractoCtaCte, setter: setFileExtractoCtaCte },
                            { idtipo: 13, archivo: fileIva, setter: setFileIva }
                        ];
                        subirDocumentos(response.datos, 0, documentos);
                    } else if (props.tipoSolicitud === 5) {
                        documentos = [
                            { idtipo: 2, archivo: fileCedulaIdentidad, setter: setFileCedulaIdentidad },
                            { idtipo: 14, archivo: fileExtractoCtaCte, setter: setFileExtractoCtaCte },
                            { idtipo: 13, archivo: fileIva, setter: setFileIva },
                            { idtipo: 27, archivo: fileConstitucionSa, setter: setFileConstitucionSa },
                            { idtipo: 28, archivo: fileActaAsamblea, setter: setFileActaAsamblea },
                            { idtipo: 38, archivo: fileCanjeAcciones, setter: setFileCanjeAcciones },
                            { idtipo: 23, archivo: fileCctVigente, setter: setFileCctVigente }
                        ];
                        subirDocumentos(response.datos, 0, documentos);
                    }
                    // subirDocumentos(response.datos, 0, documentos);
                }
            }, error => {
                Helper.log('error guardarSolicitud', error);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
            });
        }
    }

    const subirDocumentos = (datos, index, documentos) => {
        const totalArchivos = documentos.length;
        if (documentos[index] && documentos[index].archivo) {
            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            var ruta = Api.route('/archivos/subir');
            var clave = 'file';
            var params = {
                idsolicitud: datos.IDSOLICITUD,
                idarchivotipo: documentos[index].idtipo,
                numeroDocumento: datos.NUMERO_DOCUMENTO
            };
            Api.uploadImageAxios(ruta, clave, documentos[index].archivo, params, function (response) {
                Helper.log('uploadArchivo response', response);
                if (response.data.codigo && response.data.codigo !== 200) {
                    enqueueSnackbar(response.data.mensaje, { variant: 'error' });
                } else {
                    if (response.data.datos) {
                        documentos[index].setter(null);
                    }
                }
                if ((index + 1) < totalArchivos) {
                    subirDocumentos(datos, index + 1, documentos);
                }
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
            }, function (error) {
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                enqueueSnackbar('Error al subir la foto', { variant: 'error' });
                Helper.log('error uploadArchivo', error);
                if ((index + 1) < totalArchivos) {
                    subirDocumentos(datos, index + 1, documentos);
                }
            });
        } else {
            if ((index + 1) < totalArchivos) {
                subirDocumentos(datos, index + 1, documentos);
            }
        }
    }

    const onChangeDocumento = (event) => {
        const archivo = new File([event.target.files[0]], new Date().getTime() + '.' + Helper.getExtension(event.target.files[0].name), { type: event.target.files[0].type });
        switch (event.target.name) {
            case "extracto-cta-cte":
                setFileExtractoCtaCte(archivo);
                break;
            case "iva":
                setFileIva(archivo);
                break;
            case "constitucion-sa":
                setFileConstitucionSa(archivo);
                break;
            case "acta-asamblea":
                setFileActaAsamblea(archivo);
                break;
            case "canje-acciones":
                setFileCanjeAcciones(archivo);
                break;
            case "cct-vigente":
                setFileCctVigente(archivo);
                break;
            case "cedula-identidad":
                setFileCedulaIdentidad(archivo);
                break;
            default:
                break;
        }
        if (fileEdicion) {
            setFileEdicion({ ...fileEdicion, file: archivo });
        }
    };

    const verificacionReCaptcha = (token) => {
        setTokenReCaptcha(token);
        console.log('token', token);
    };
    const cerrarModalFile = () => {
        setModalFile(false);
        setFileEdicion(null);
    };
    const abrirModalFile = (archivo) => {
        setFileEdicion({ ...archivo });
        setModalFile(true);
    };

    const handleMapApiLoaded = (map, maps) => {
        // use map and maps objects
        // map.addListener("click", (e) => {
        //     actualizarCoordenada(e);
        // });
    };
    const onClickMapa = ({ x, y, lat, lng, event }) => {
        setCoordenadas({
            lat: lat,
            lng: lng,
        });
        setData({
            ...data,
            LATITUDE: lat,
            LONGITUDE: lng
        });
        setErrores({
            ...errores,
            LATITUDE: false,
            LONGITUDE: false
        });
    };
    const solicitarContacto = () => {
        setShowModalError(false);
        setErrores(errorInicial);
        dispatch(AppActions.setMensajePredefinido("Necesito un contacto para hacer una solicitud de préstamo"));
        scroller.scrollTo('contacto', {
            duration: 1000,
            delay: 100,
            smooth: true,
            offset: -100, // Scrolls to element + 50 pixels down the page
        })
    };
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <div className="w3-block formulario-component">
                    <div className="form-container bs-bbox">
                        <form className="w3-block bs-bbox">
                            {props.tipoSolicitud === 5 ? <fieldset>
                                <legend className="w3-text-theme xbold">Datos de la Empresa</legend>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Razón social<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.RAZON_SOCIAL_EMPRESA ? " input-error" : "")}
                                            value={data.RAZON_SOCIAL_EMPRESA}
                                            onChange={event => onChangeForm(event, 'RAZON_SOCIAL_EMPRESA')}></input>
                                    </div>

                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>RUC<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.RUC_EMPRESA ? " input-error" : "")}
                                            value={data.RUC_EMPRESA}
                                            onChange={event => onChangeForm(event, 'RUC_EMPRESA')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Teléfono<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.TELEFONO_EMPRESA ? " input-error" : "")}
                                            value={data.TELEFONO_EMPRESA}
                                            onChange={event => onChangeForm(event, 'TELEFONO_EMPRESA')}></input>
                                    </div>
                                    <div className="w3-col l8 bs-bbox w3-padding inputs-col">
                                        <label>Dirección<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.DIRECCION_EMPRESA ? " input-error" : "")}
                                            value={data.DIRECCION_EMPRESA}
                                            onChange={event => onChangeForm(event, 'DIRECCION_EMPRESA')}></input>
                                    </div>
                                </div>
                            </fieldset> : null}

                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Datos  { props.tipoSolicitud === 5 ? "/ Firmante" : "personales" }</legend>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Nombre<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.NOMBRE ? " input-error" : "")}
                                            value={data.NOMBRE}
                                            onChange={event => onChangeForm(event, 'NOMBRE')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Apellido<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.APELLIDO ? " input-error" : "")}
                                            value={data.APELLIDO}
                                            onChange={event => onChangeForm(event, 'APELLIDO')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Nº de documento<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.NUMERO_DOCUMENTO ? " input-error" : "")}
                                            value={data.NUMERO_DOCUMENTO}
                                            onChange={event => onChangeForm(event, 'NUMERO_DOCUMENTO')}></input>
                                    </div>
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectNacionalidad value={data.IDNACIONALIDAD} onChange={onChangeNacionalidad} error={errores.IDNACIONALIDAD} /><br /><br />
                                    </div>
                                    {/* <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Nacionalidad<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.NACIONALIDAD ? " input-error" : "")}
                                            value={data.NACIONALIDAD}
                                            onChange={event => onChangeForm(event, 'NACIONALIDAD')}></input>
                                    </div> */}
                                    <div className="w3-col l4 bs-bbox inputs-col" style={{ padding: "28px 20px 0px 20px", boxSizing: "border-box" }}>
                                        {/* <label>Fecha de nacimiento<span className="w3-text-theme">&#42;</span></label>
                                            <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.FECHA_NACIMIENTO ? " input-error" : "")}
                                                value={data.FECHA_NACIMIENTO}
                                                onChange={event => onChangeForm(event, 'FECHA_NACIMIENTO')}></input> */}
                                        <DatePicker
                                            label={<label>Fecha de nacimiento<span className="w3-text-theme">&#42;</span></label>}
                                            maxDate={maxDate}
                                            value={data.FECHA_NACIMIENTO}
                                            onChange={(newValue) => onChangeFechaNacimiento(newValue)}
                                            renderInput={(params) => <TextField size="small" {...params} />}
                                        />
                                    </div>
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectEstadoCivil value={data.IDESTADO_CIVIL} onChange={onChangeEstadoCivil} error={errores.IDESTADO_CIVIL} /><br /><br />
                                    </div>
                                    {/* <div className="w3-col l4 bs-bbox w3-padding">
                                        <label>Estado civil<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.ESTADO_CIVIL ? " input-error" : "")}
                                            value={data.ESTADO_CIVIL}
                                            onChange={event => onChangeForm(event, 'ESTADO_CIVIL')}></input>
                                    </div> */}

                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Teléfono</label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.TELEFONO ? " input-error" : "")}
                                            value={data.TELEFONO}
                                            onChange={event => onChangeForm(event, 'TELEFONO')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Celular<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.CELULAR ? " input-error" : "")}
                                            value={data.CELULAR}
                                            onChange={event => onChangeForm(event, 'CELULAR')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Email</label>
                                        <input type="email" className={"w3-input w3-transparent w3-round-large my-input" + (errores.EMAIL ? " input-error" : "")}
                                            value={data.EMAIL}
                                            onChange={event => onChangeForm(event, 'EMAIL')}></input>
                                    </div>
                                </div>
                            </fieldset>

                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Domicilio</legend>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 bs-bbox w3-padding">
                                        <label>Especificar<span className="w3-text-theme">&#42;</span></label><br />
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-label="domicilio"
                                                name="radio-buttons-group"
                                                value={data.IDTIPO_CASA}
                                                onChange={event => onChangeForm(event, 'IDTIPO_CASA')}
                                            >
                                                {tipoCasaOptions.map(tipo => <FormControlLabel key={tipo.value} value={tipo.value} control={<Radio />} label={tipo.label} />)}
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                    <div className="w3-col l8 bs-bbox w3-padding inputs-col">
                                        <label>Dirección<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.DIRECCION ? " input-error" : "")}
                                            value={data.DIRECCION}
                                            onChange={event => onChangeForm(event, 'DIRECCION')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox col-select inputs-col">
                                        <SelectCiudad value={data.IDCIUDAD} onChange={onChangeCiudad} error={errores.IDCIUDAD} />
                                    </div>
                                    <div className="w3-col l4 bs-bbox col-select inputs-col">
                                        <SelectBarrio barrios={barrios} value={data.IDBARRIO} onChange={event => onChangeForm(event, 'IDBARRIO')} />
                                    </div>
                                </div>
                            </fieldset>
                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Datos laborales</legend>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectProfesion value={data.IDPROFESION} onChange={onChangeProfesion} error={errores.IDPROFESION} />
                                    </div>
                                    {/* <div className="w3-col l4 bs-bbox w3-padding">
                                        <label>Profesión<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.PROFESION ? " input-error" : "")}
                                            value={data.PROFESION}
                                            onChange={event => onChangeForm(event, 'PROFESION')}></input>
                                    </div> */}
                                    <div className="w3-col l8 bs-bbox w3-padding inputs-col">
                                        <label>Domicilio laboral<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.DOMICILIO_LABORAL ? " input-error" : "")}
                                            value={data.DOMICILIO_LABORAL}
                                            onChange={event => onChangeForm(event, 'DOMICILIO_LABORAL')}></input>
                                    </div>
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectCargo value={data.IDCARGO} onChange={onChangeCargo} error={errores.IDCARGO} />
                                    </div>
                                    {/* <div className="w3-col l4 bs-bbox w3-padding">
                                        <label>Cargo<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.CARGO_LABORAL ? " input-error" : "")}
                                            value={data.CARGO_LABORAL}
                                            onChange={event => onChangeForm(event, 'CARGO_LABORAL')}></input>
                                    </div> */}
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Departamento<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.DEPARTAMENTO_LABORAL ? " input-error" : "")}
                                            value={data.DEPARTAMENTO_LABORAL}
                                            onChange={event => onChangeForm(event, 'DEPARTAMENTO_LABORAL')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox col-select inputs-col">
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="select-antiguedad-anhos">Antiguedad<span className="w3-text-theme">&#42;</span></InputLabel>
                                            <Select
                                                className={errores.ANTIGUEDAD_ANHO ? "w3-border w3-border-red" : "w3"}
                                                labelId="select-antiguedad-anhos"
                                                id="select-antiguedad-anhos"
                                                value={data.ANTIGUEDAD_ANHO}
                                                label="Antiguedad"
                                                onChange={event => onChangeForm(event, 'ANTIGUEDAD_ANHO')}
                                            >
                                                {antiguedadAnhosOptions.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Teléfono<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.TELEFONO_LABORAL ? " input-error" : "")}
                                            value={data.TELEFONO_LABORAL}
                                            onChange={event => onChangeForm(event, 'TELEFONO_LABORAL')}></input>
                                    </div>
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <label>Email</label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.EMAIL_LABORAL ? " input-error" : "")}
                                            value={data.EMAIL_LABORAL}
                                            onChange={event => onChangeForm(event, 'EMAIL_LABORAL')}></input>
                                    </div>
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectCiudad value={data.IDCIUDAD_LABORAL} onChange={onChangeCiudadLaboral} error={errores.IDCIUDAD_LABORAL} />
                                    </div>
                                    <div className="w3-col l4 col-select inputs-col">
                                        <SelectBarrio barrios={barriosLaborales} value={data.IDBARRIO_LABORAL} onChange={event => onChangeForm(event, 'IDBARRIO_LABORAL')} />
                                    </div>

                                    <div className="w3-col l12 w3-padding bs-bbox">
                                        <label>Ubicación (Acerca el mapa para una mayor exactitud al marcar la ubicación) {errores.LATITUDE || errores.LONGITUDE ? <span className="w3-text-red">Indicar ubicación</span> : null}</label>
                                        <div style={{ height: 300, width: '100%' }} className={errores.LATITUDE || errores.LONGITUDE ? "w3-border w3-border-red" : "w3"}>
                                            <GoogleMapReact
                                                bootstrapURLKeys={{ key: "AIzaSyDm3lwbaJo9Meil9pfGXQVI0fkS4z0Er5E" }}
                                                defaultCenter={{ lat: -25.313463, lng: -57.562537 }}
                                                defaultZoom={12}
                                                onGoogleApiLoaded={({ map, maps }) => handleMapApiLoaded(map, maps)}
                                                onClick={onClickMapa}
                                            >
                                                {coordenadas ? <Marcador
                                                    lat={coordenadas.lat}
                                                    lng={coordenadas.lng}
                                                    text="Marcador del mapa"
                                                /> : null}
                                            </GoogleMapReact>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Referencias personales</legend>
                                {data.REFERENCIAS_PERSONALES.map((referencia, index) => <div key={'ref' + index} className="w3-row bs-bbox w3-border">
                                    <div className="w3-col bs-bbox" style={{ paddingTop: 30, paddingLeft: 10, width: 30 }}>
                                        <label><span className="w3-text-theme">{index + 1}- </span></label>
                                    </div>
                                    <div className="w3-col l6 bs-bbox w3-padding">
                                        <label>Nombre y apellido<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.REFERENCIAS_PERSONALES[index].NOMBRE ? " input-error" : "")}
                                            value={referencia.NOMBRE}
                                            onChange={event => onChangeReferencia(index, event, 'NOMBRE')}></input>
                                    </div>
                                    <div className="w3-col l5 bs-bbox w3-padding">
                                        <label>Teléfono<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.REFERENCIAS_PERSONALES[index].TELEFONO ? " input-error" : "")}
                                            value={referencia.TELEFONO}
                                            onChange={event => onChangeReferencia(index, event, 'TELEFONO')}></input>
                                    </div>
                                </div>)}
                            </fieldset>
                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Documentos</legend>
                                {props.tipoSolicitud === 4 ? <div className="w3-row bs-bbox">
                                    {fileExtractoCtaCte || fileCedulaIdentidad || fileIva ? <div className="w3-col l12 bs-bbox w3-padding w3-center w3-border">
                                        <span>Documentos adjuntados</span>
                                        <div className="w3-row">
                                            <div className="w3-col col-thumbs">
                                                {fileExtractoCtaCte ? <div>
                                                    <FileThumb file={fileExtractoCtaCte} label="3 últimos Extracto de Cta. Cte." onClick={() => abrirModalFile({ file: fileExtractoCtaCte, label: "3 últimos Extracto de Cta. Cte.", documento: "extracto-cta-cte" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileIva ? <div>
                                                    <FileThumb file={fileIva} label="3 últimos IVA" onClick={() => abrirModalFile({ file: fileIva, label: "3 últimos IVA", documento: "iva" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileCedulaIdentidad ? <div>
                                                    <FileThumb file={fileCedulaIdentidad} label="Cédula de identidad" onClick={() => abrirModalFile({ file: fileCedulaIdentidad, label: "Cédula de identidad", documento: "cedula-identidad" })} />
                                                </div> : null}
                                            </div>
                                        </div>
                                    </div> : null}
                                    {!fileExtractoCtaCte ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-extracto-cta-cte" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar 3 últimos Extracto de Cta. Cte.
                                        </label>
                                        <input id="upload-extracto-cta-cte" accept={acceptFiles} name="extracto-cta-cte" type="file" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileIva ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-iva" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar 3 últimos IVA
                                        </label>
                                        <input id="upload-iva" type="file" accept={acceptFiles} name="iva" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileCedulaIdentidad ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-cedula" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar cédula de identidad
                                        </label>
                                        <input id="upload-cedula" type="file" accept={acceptFiles} name="cedula-identidad" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                </div> : null}
                                {props.tipoSolicitud === 5 ? <div className="w3-row bs-bbox">
                                    {(fileExtractoCtaCte || fileCedulaIdentidad || fileIva || fileConstitucionSa || fileActaAsamblea || fileCanjeAcciones || fileCctVigente) ? <div className="w3-col l12 bs-bbox w3-padding w3-center w3-border">
                                        <span>Documentos adjuntados</span>
                                        <div className="w3-row">
                                            <div className="w3-col col-thumbs">
                                                {fileExtractoCtaCte ? <div>
                                                    <FileThumb file={fileExtractoCtaCte} label="3 últimos Extracto de Cta. Cte." onClick={() => abrirModalFile({ file: fileExtractoCtaCte, label: "3 últimos Extracto de Cta. Cte.", documento: "extracto-cta-cte" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileIva ? <div>
                                                    <FileThumb file={fileIva} label="3 Ultimos IVA" onClick={() => abrirModalFile({ file: fileIva, label: "3 Ultimos IVA", documento: "iva" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileConstitucionSa ? <div>
                                                    <FileThumb file={fileConstitucionSa} label="Constitución de la Sociedad" onClick={() => abrirModalFile({ file: fileConstitucionSa, label: "Constitución de la Sociedad", documento: "constitucion-sa" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileActaAsamblea ? <div>
                                                    <FileThumb file={fileActaAsamblea} label="Última acta de asamblea" onClick={() => abrirModalFile({ file: fileActaAsamblea, label: "Ultima acta de asamblea", documento: "acta-asamblea" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileCanjeAcciones ? <div>
                                                    <FileThumb file={fileCanjeAcciones} label="Canje de acciones" onClick={() => abrirModalFile({ file: fileCanjeAcciones, label: "Canje de acciones", documento: "canje-acciones" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileCedulaIdentidad ? <div>
                                                    <FileThumb file={fileCedulaIdentidad} label="Cedula de identidad" onClick={() => abrirModalFile({ file: fileCedulaIdentidad, label: "Cédula de identidad", documento: "cedula-identidad" })} />
                                                </div> : null}
                                            </div>
                                            <div className="w3-col col-thumbs">
                                                {fileCctVigente ? <div>
                                                    <FileThumb file={fileCctVigente} label="CCT Vigente" onClick={() => abrirModalFile({ file: fileCctVigente, label: "CCT Vigente", documento: "cct-vigente" })} />
                                                </div> : null}
                                            </div>
                                        </div>
                                    </div> : null}
                                    {!fileExtractoCtaCte ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-extracto-cta-cte" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar 3 últimos Extracto de Cta. Cte.
                                        </label>
                                        <input id="upload-extracto-cta-cte" accept={acceptFiles} name="extracto-cta-cte" type="file" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileIva ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-iva" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar 3 últimos IVA
                                        </label>
                                        <input id="upload-iva" type="file" accept={acceptFiles} name="iva" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileConstitucionSa ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-constitucion" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Constitución de la Sociedad
                                        </label>
                                        <input id="upload-constitucion" type="file" accept={acceptFiles} name="constitucion-sa" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileActaAsamblea ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-acta-asamblea" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Última acta de asamblea
                                        </label>
                                        <input id="upload-acta-asamblea" type="file" accept={acceptFiles} name="acta-asamblea" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileCanjeAcciones ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-canje-acciones" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Canje de acciones
                                        </label>
                                        <input id="upload-canje-acciones" type="file" accept={acceptFiles} name="canje-acciones" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileCedulaIdentidad ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-cedula" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> Adjuntar cédula de identidad
                                        </label>
                                        <input id="upload-cedula" type="file" accept={acceptFiles} name="cedula-identidad" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                    {!fileCctVigente ? <div className="w3-col l12 bs-bbox w3-padding row-inputs">
                                        <label htmlFor="upload-cct" className="w3-btn w3-round-large w3-light-gray w3-border botones-inputs">
                                            <FontAwesomeIcon icon={faPlus} color="#000000" /> CCT Vigente
                                        </label>
                                        <input id="upload-cct" type="file" accept={acceptFiles} name="cct-vigente" onChange={onChangeDocumento} style={{ display: 'none' }} />
                                    </div> : null}
                                </div> : null}
                            </fieldset>
                            <br />
                            <fieldset>
                                <legend className="w3-text-theme xbold">Cantidad de cheques y monto total</legend>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 bs-bbox w3-padding inputs-col">
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="select-cantidad-cheques">Cantidad de cheques</InputLabel>
                                            <Select
                                                labelId="select-cantidad-cheques"
                                                id="select-cantidad-cheques"
                                                value={data.NUM_CHEQUES}
                                                label="Cantidad de cheques"
                                                onChange={event => onChangeForm(event, 'NUM_CHEQUES')}
                                            >
                                                {cantChequesOptions.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="w3-row bs-bbox">
                                    <div className="w3-col l4 bs-bbox w3-padding">
                                        <label>Monto total<span className="w3-text-theme">&#42;</span></label>
                                        <input type="text" className={"w3-input w3-transparent w3-round-large my-input" + (errores.MONTO ? " input-error" : "")}
                                            value={data.MONTO}
                                            onChange={event => onChangeForm(event, 'MONTO')}></input>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="w3-block w3-padding">
                                <label><FontAwesomeIcon icon={faAsterisk} color="#0a5aa7" />  Datos requeridos</label>
                            </div>
                            <div className="w3-row">
                                <div className="w3-col l12 bs-bbox w3-padding w3-center">
                                    <GoogleReCaptchaProvider reCaptchaKey="6Lfb1tcdAAAAAFxdJs1LJy4XyKzlT2J_SVeqQ_Sk">
                                        {/* <GoogleReCaptcha onVerify={(token) => verificacionReCaptcha(token)} /> */}
                                    </GoogleReCaptchaProvider>
                                </div>
                            </div>
                            <div className="w3-row">
                                <div className="w3-col l12 bs-bbox w3-padding w3-center">
                                    <button className="w3-btn w3-xlarge boton-solicitar" type="button" onClick={solicitar}>Solicitar</button>
                                    {msgEnvioExitoso ? <p className="w3-text-white">{msgEnvioExitoso}</p> : null}
                                </div>
                            </div>
                        </form>
                    </div>
                    <ModalEdicionFile show={modalFile} edicion={fileEdicion} hide={cerrarModalFile} onChangeFile={onChangeDocumento} acceptFiles={acceptFiles} />
                    <ModalExito show={showModalExito} hide={() => setShowModalExito(false)} />
                    <ModalError show={showModalError} hide={() => setShowModalError(false)} solicitarContacto={() => solicitarContacto()} />
                </div>
            </LocalizationProvider>
        </>
    );
}
export default FormularioDescuentoCheques;